import { Injectable } from '@angular/core';
import { runtimeEventManager } from '@wm/core';
import { find, forEach, get, set } from 'lodash-es';

interface WidgetGroupType {
  name: string;
  namekey?: string;
  iconclass?: string;
  feature?: string;
  parent?: string;
  subGroups?: Array<WidgetGroupType>;
  widgets?: Array<any>;
  filteredWidgets?: Array<any>
}

let widgetProps: {[key: string]: any} = {},
  widgetGroups: Array<WidgetGroupType> = [],
  mainGroups: Array<any> = [],
  i = 0;

@Injectable({
  providedIn: 'root'
})
export class WidgetPropertiesProvider {
  widgetsList: any;


  constructor() {
    this.initWidgetGroups();
    this.combineGroups();
    runtimeEventManager.setService('widgetPropertiesProvider', this);
  }

  initWidgetGroups() {
    let subGroups: Array<WidgetGroupType> = [
      {
        "name": "widgets",
        "namekey": "LABEL_WIDGETS",
        "iconclass": "widgets",
        "feature": "components.widgets"
      },
      {
        "name": "Mywidgets",
        "namekey": "LABEL_MY_WIDGETS",
        "iconclass": "widgets",
        "feature": "components.mywidgets"
      },
      {
        "name": "WmxWidgets",
        "namekey": "LABEL_WMX_WIDGETS",
        "iconclass": "widgets",
        "feature": "components.wmxwidgets"
      },
      {
        "name": "prefabs",
        "namekey": "LABEL_PREFABS",
        "iconclass": "prefab",
        "feature": "components.prefabs"
      },
      {
      "name": "commonWidgets",
      "namekey": "LABEL_WIDGETS_COMMONLY_USED",
      "parent": "widgets",
      "feature": "components.widgets.commonWidgets",
      },
      {
        "name": "livewidgets",
        "namekey": "LABEL_LIVE_WIDGETS",
        "parent": "widgets",
        "feature": "components.widgets.liveWidgets"
      },
      {
        "name": "container",
        "namekey": "LABEL_WIDGETS_CONTAINER",
        "parent": "widgets",
        "feature": "components.layouts.container"
      },
      {
        "name": "formwidgets",
        "namekey": "LABEL_WIDGETS_FORMWIDGETS",
        "parent": "widgets",
        "feature": "components.widgets.formWidgets"
      },
      {
        "name": "basicwidgets",
        "namekey": "LABEL_WIDGETS_BASICWIDGETS",
        "parent": "widgets",
        "feature": "components.widgets.basicWidgets"
      },
      {
        "name": "charts",
        "namekey": "LABEL_WIDGETS_CHARTS",
        "parent": "widgets",
        "feature": "components.widgets.charts"
      },
      {
        "name": "navigation",
        "namekey": "LABEL_WIDGETS_NAVIGATION",
        "parent": "widgets",
        "feature": "components.layouts.navigation"
      },
      {
        "name": "advancedwidgets",
        "namekey": "LABEL_ADVANCED_WIDGETS",
        "parent": "widgets",
        "feature": "components.widgets.advancedWidgets"
      },
      {
        "name": "dialogs",
        "namekey": "LABEL_WIDGETS_DIALOGS",
        "parent": "widgets",
        "feature": "components.widgets.dialogs"
      }
    ];
    widgetGroups = widgetGroups.concat(subGroups);
  }

  /* modify mainGroup */
  modifyGroup(groupName: string, groupProperty: string, propertyNewValue: string) {
    /* Loop through the groups */
    let group;
    for (i = 0; i < mainGroups.length; i += 1) {
      group = mainGroups[i];
      if (group.name === groupName) {
        group[groupProperty] = propertyNewValue;
        break;
      }
    }
  }

  /* modify subGroup */
  modifySubGroup(subGroupName: string, subGroupProperty: string, propertyNewValue: string) {
    /* Loop through the sub-groups */
    let subGroup;
    for (i = 0; i < widgetGroups.length; i += 1) {
      subGroup = widgetGroups[i];
      if (subGroup.name === subGroupName) {
        set(subGroup, subGroupProperty, propertyNewValue);
        break;
      }
    }
  }

  combineGroups() {
    /* combine the subgroups and groups and create a tree like structure */
    let length = widgetGroups.length,
      group = null,
      map: {[key:string]: Array<any>} = {};

    mainGroups = [];

    for (i = 0; i < length; i += 1) {
      group = widgetGroups[i];
      /* MainGroups will not have a parent */
      if (!group.parent) {
        map[group.name] = [];
        mainGroups.push(group);
        group.subGroups = map[group.name];
      } else if (map[group.parent]) {
        /* ChildGroup/subGroup will have parent, inject the childGroup into MainGroup */
        map[group.parent]?.push(group);
      }
    }
  }

  /* Widget calls this function with the widgetType[eg. wm-text] and properties [eg, isResizable, isDraggable] */
  register(widgetType: string, props: {[key:string]: any}) {
    widgetProps[widgetType] = props;
  }

  /* getConfig returns the properties of a widget by its type. If type is not passed it returns null(means the widget is not registerd) */
  getConfig(widgetType: string) {
    return widgetType ? widgetProps[widgetType] : {};
  }

  /* add a main group to the components */
  addGroup(groupDetails: WidgetGroupType) {
    if (!find(widgetGroups, {'name': groupDetails.name})) {
      widgetGroups.push(groupDetails);
    }
  }

  /* When a subGroup need to be added dynamically call this method with the subGroup details[eg. name, nameKey, parent] */
  addSubGroup(subGroupDetails: WidgetGroupType) {

    let index;

    /* Do not process the request if the subGroupDetails are not passed */
    if (!subGroupDetails) {
      return;
    }

    /* name/namekey & parent are mandatory for a subgroup. If these details are not passed do not process the request */
    if ((!subGroupDetails.name && !subGroupDetails.namekey) || !subGroupDetails.parent) {
      return;
    }

    /* initialize the subgroup.widgets if the argument is not passed */
    if (!subGroupDetails.widgets) {
      subGroupDetails.widgets = [];
    }
    /*Iterate through the widgetGroups and check if the specified sub-group already exists..
     * If it exists, return the object..
     * Else add it to the widgetGroups and return.*/
    for (index = 0; index < widgetGroups.length; index += 1) {
      if (widgetGroups[index].name === subGroupDetails.name && widgetGroups[index].parent === subGroupDetails.parent) {
        if ((!widgetGroups[index].widgets)) {
          widgetGroups[index].widgets = subGroupDetails.widgets;
        } else {
          return widgetGroups[index];
        }
      }
    }

    /* append parent category to each widget object */
    forEach(subGroupDetails.widgets, (widget) => {
      widget.category = subGroupDetails.name;
    });

    if (!find(widgetGroups, {'name': subGroupDetails.name})) {
      widgetGroups.push(subGroupDetails);
    }
    this.combineGroups();

    /*return the newly added subgroup*/
    return subGroupDetails;
  }

  getGroup(groupName: string) {
    let index;
    if (!groupName) {
      return;
    }

    /* mainGroups is an array. find the needed mainGroup using the mainGroupName */
    for (index = 0; index < mainGroups.length; index += 1) {
      if (mainGroups[index].name === groupName) {
        return mainGroups[index];
      }
    }
  }

  /* getSubGroup returns the reference of subGroup when groupName and subGroupName are passed */
  getSubGroup(groupName: string, subGroupName: string) {
    /* Do not process the request if groupName and subGroupName are not passed in */
    if (!groupName || !subGroupName) {
      return;
    }

    let index, subGroup = null, group = this.getGroup(groupName);

    /* subGroups is an array. find the needed subGroup using the subGroupName */
    for (index = 0; index < group.subGroups.length; index += 1) {
      subGroup = group.subGroups[index];
      if (subGroup.name === subGroupName) {
        break;
      }
    }

    return subGroup;
  }

  /* return the mainGroups */
  getGroups() {
    return mainGroups;
  }

  /*Function to return the widget types.*/
  getWidgetTypes() {
    return Object.keys(widgetProps);
  }

  deleteDbWidgets() {
    let newWidgetGroups: Array<WidgetGroupType> = [];
    /*Loop through the widget groups.*/
    widgetGroups.forEach((widgetGroup) => {
      /*Construct a new array with the non-db widgets*/
      if (!get(widgetGroup, 'projectID')) {
        newWidgetGroups.push(widgetGroup);
      }
    });
    widgetGroups = newWidgetGroups;
    this.combineGroups();
  }
}
